<template>
  <ExportFormatModal
    :loading="loading || exportLoading"
    @export="handleExport"
  >
    <template #button>
      <Button
        class="button--export"
        :loading="loading || exportLoading"
        :hide="hide"
        size="m"
        color="grey"
        :disabled="disabled"
        icon="download"
        data-testid="export-btn"
      >
        {{ $t(text) }}
      </Button>
    </template>
  </ExportFormatModal>
</template>

<script>
import Button from '@/components/ui/button/Button';
import ExportFormatModal from '@/components/ui/modals/ExportFormatModal';
import { mapState } from 'vuex';

export default {
  name: 'ButtonExport',
  components: { Button, ExportFormatModal },
  props: {
    hide: Boolean,
    loading: Boolean,
    disabled: Boolean,
    text: {
      type: String,
      default: 'table.export-data'
    }
  },
  computed: {
    ...mapState(['exportLoading'])
  },
  methods: {
    handleExport(format) {
      this.$emit('export', format);
    }
  }
};
</script>
